// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__g9er5","tall-image-sign":"tall-image-sign__9-p9R","icon-info":"icon-info__Iut0s"};